export default {
  props: {
    showMask: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    _click: function _click() {
      this.$emit('click');
    },
    beforeEnter: function beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter: function enter(el, done) {
      window.Velocity(el, {
        opacity: 0.7
      }, {
        complete: done,
        display: 'block'
      });
    },
    leave: function leave(el, done) {
      window.Velocity(el, {
        opacity: 0
      }, {
        complate: done,
        display: 'none'
      });
    }
  }
};